
const KeyFiguresSection = (props) => {
  const tooltipHeight = 110;
  return (
    <div
      className="key-figures-wrapper"
      style={{
        top: props.height,
        width: props.tooltipWidth,
        display:
          props.tooltipStatus &&
          props.tooltipStatus.trend &&
          props.tooltipStatus.content
            ? "block"
            : "none",
      }}
    >
      {props.tooltipStatus && (
        <div>
          <p className="f-med mxy-5">
            <strong>
              {props.tooltipStatus
                ? props.trendCountries[props.tooltipStatus.country] && props.tooltipStatus.country!== "United States"
                  ? props.trendCountries[props.tooltipStatus.country]
                      .countryTitle
                  : props.tooltipStatus.country
                : null}
            </strong>
          </p>
          <p className="f-small mxy-5">
            {props.tooltipStatus && props.tooltipStatus.content}
          </p>
          {props.tooltipStatus.link && (
            <p className="f-small mxy-10">
              <a href={props.tooltipStatus.link}>Read More</a>
            </p>
          )}
        </div>
      )}
 
    </div>
  );
};

export default KeyFiguresSection;
